import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-selectInput-control-label-view, [app-selectInput-control-label-view]',
  templateUrl: './selectInput-control-label-view.component.html',
  styleUrls: ['./selectInput-control-label-view.component.scss']
})
export class SelectInputControlLabelViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
